import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InstructionService } from '../../../services/instruction.service';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class SliderComponent implements OnInit {
  @Input('form') form: FormGroup;
  @Input('controlName') controlName: string;
  @Input('groupName') groupName: string;
  @Input('range') range: number[];
  @Input('label') label: string[];
  @Output('valueChange') valueChange = new EventEmitter<{ value: number }>();

  warning: string;

  constructor(private instructionService: InstructionService) {}

  ngOnInit(): void {
    // in order to also get question answer if the slider wasn't touched / skipped or the VP was okay with the initial value (workaround, easier to use a formControlName)
    // this.valueChange.emit({ value: this.initialValue });
    this.warning = this.instructionService.getTranslationsForTerm(
      'SLIDER_WARNING'
    );
  }

  onChange(e: Event) {
    this.valueChange.emit({ value: +(<HTMLInputElement>e.target).value });
  }

  onClick(e: Event) {
    const control = this.getFormGroup().controls[this.controlName];
    if (!control.touched) {
      control.setValue(+(<HTMLInputElement>e.target).value);
    }
  }

  getFormGroup() {
    return this.form.controls[`${this.controlName}_Group`] as FormGroup;
  }
}
